export const DESIGN_SUCCESS = 1;
export const DESIGN_FAILED = 2;
export const DESIGN_IDENTIFY_FAILED = 7;
export const DESIGN_AURORA_DB = 8;